import axios from 'axios'

export default {
    getList(params) {
        return axios.get('/broadcast-governance', { params })
    },

    getByReferralId(referralId) {
        return axios.get(`/broadcast-governance/by-referral/${referralId}`)
    },

    stop(broadcastId) {
        return axios.post(`/broadcast-governance/${broadcastId}/stop`)
    },

    runRound(broadcastId) {
        return axios.post(`/broadcast-governance/${broadcastId}/run-round`)
    },
}
